"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Palette is taken from mnemonics design manual
 * All palettes are created using
 * https://material.io/design/color/the-color-system.html#tools-for-picking-colors
 */
const Amber = {
    50: "#FDFCE5",
    100: "#FAF6BF",
    200: "#F6EF95",
    300: "#F2E96B",
    400: "#F0E549",
    500: "#EDE022",
    600: "#EDCE1C",
    700: "#ECB610",
    800: "#EB9E01",
    900: "#E77500",
    A100: "#FAF6BF",
    A200: "#F6EF95",
    A400: "#F0E549",
    A700: "#ECB610",
};
exports.default = Amber;
